module.exports = __webpack_public_path__ + "img/image_cellmate_gen2_cg.294ca7a8.png";